import {IVanService} from "../../domain/leasing/IVanService";
import {Leasings} from "../../../../../server/src/base/entities/leasing/Leasings";
import {LeasingType, SerializedLeasingType} from "../../../../../server/src/base/entities/leasing/LeasingType";
import {Vans} from "../../../../../server/src/base/entities/leasing/Vans";
import {ApiAccessService} from "../api/ApiAccessService";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";

export class VanService implements IVanService{

    private apiAccessService:ApiAccessService;

    constructor(apiAccessService:ApiAccessService){
        this.apiAccessService = apiAccessService;
    }

    public Leasings(): Promise<Leasings> {
        return this.apiAccessService.Get("leasing/leasings", Leasings);
    }

    public Vans(type: LeasingType): Promise<Vans> {
        return this.apiAccessService.Get("leasing/van/get/" + type, Vans);
    }

    public Get(id: string): Promise<Van> {
        return this.apiAccessService.Get("leasing/van/" + id, Van);
    }

    public Add(van:Van): Promise<void> {
        return this.apiAccessService.Post("leasing/van/add", van);
    }

    public Remove(vanId: string): Promise<void> {
        return this.apiAccessService.Delete("leasing/van/delete/" + vanId);
    }

    public Enable(vanId: string): Promise<void> {
        return this.apiAccessService.Patch("leasing/van/enable/" + vanId);
    }

    public Disable(vanId: string): Promise<void> {
        return this.apiAccessService.Patch("leasing/van/disable/" + vanId);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/leasing/VanService.ts